export default (params) => ({
  trigger: {
    name: 'product_trade_in_overlay.close_overlay',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'brand',
          'product',
          'condition',
          'instructions',
        ],
      },
    },
    event: {
      name: 'close',
    },
  },
});
